import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'
import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'

import type {GlobalButtonStyleParams} from '../../../../../../utils/useGlobalButtonStyle'
import {colorMetadata, fontMetadata, numberMetadata} from '../../../../../../utils/builderMetadata'

export type ButtonStylesParams = {
  buttonDefaultFont: StyleParamType.Font
  buttonDefaultColor: StyleParamType.Color
  buttonDefaultFillColor: StyleParamType.Color
  buttonDefaultBorderWidth: StyleParamType.Number
  buttonDefaultBorderColor: StyleParamType.Color
  buttonDefaultCornerRadiusTopLeft: StyleParamType.Number
  buttonDefaultCornerRadiusTopRight: StyleParamType.Number
  buttonDefaultCornerRadiusBottomLeft: StyleParamType.Number
  buttonDefaultCornerRadiusBottomRight: StyleParamType.Number

  buttonHoverFont: StyleParamType.Font
  buttonHoverColor: StyleParamType.Color
  buttonHoverFillColor: StyleParamType.Color
  buttonHoverBorderColor: StyleParamType.Color
}

export const buttonStylesParams = createStylesParams<ButtonStylesParams>({
  buttonDefaultFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  buttonDefaultColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: colorMetadata(StyleType.color, 'color-1'),
  },
  buttonDefaultFillColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-8', 1),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-8', 1),
  },
  buttonDefaultBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 0}),
  },
  buttonDefaultBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.12),
    metadata: colorMetadata(StyleType.borderColor, 'color-line', 0.12),
  },
  buttonDefaultCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderTopLeftRadius, {defaultValue: 0}),
  },
  buttonDefaultCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderTopRightRadius, {defaultValue: 0}),
  },
  buttonDefaultCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderBottomLeftRadius, {defaultValue: 0}),
  },
  buttonDefaultCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderBottomRightRadius, {defaultValue: 0}),
  },

  buttonHoverFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
      style: {bold: false, italic: false, underline: true},
    }),

    metadata: fontMetadata('Body-M', 16),
  },
  buttonHoverColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1'),
    metadata: colorMetadata(StyleType.color, 'color-1'),
  },
  buttonHoverFillColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-action', 1),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-action', 1),
  },
  buttonHoverBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-line', 0.12),
    metadata: colorMetadata(StyleType.borderColor, 'color-line', 0.12),
  },
})

export const globalButtonStyleParams: GlobalButtonStyleParams = {
  textColor: buttonStylesParams.buttonDefaultColor,
  fillColor: buttonStylesParams.buttonDefaultFillColor,
  borderColor: buttonStylesParams.buttonDefaultBorderColor,
  borderWidth: buttonStylesParams.buttonDefaultBorderWidth,
  hoverTextColor: buttonStylesParams.buttonHoverColor,
  hoverFillColor: buttonStylesParams.buttonHoverFillColor,
  hoverBorderColor: buttonStylesParams.buttonHoverBorderColor,
}
